import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Input, Popconfirm, message } from 'antd'
import styled from 'styled-components'
import { actions } from '../../redux/modules/templatesActions'
import { actions as tasksActions } from '../../redux/modules/tasksActions'
import WorkOrderEditor from '../../components/WorkOrderEditor'
import history from '../../history'
import _ from 'lodash'

const Container = styled.div`
  padding: 25px;
`
const MarginTop = styled.div`
  margin-top: 15px;
`
const propTypes = {}
const { TextArea } = Input

class TemplatesWorkOrder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentKey: 'work_order',
      currentId: +this.props.match.params.templateId,
      workOrderItems: []
    }

    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: this.state.currentId
    })
    this.props.getAllTasks()
  }

  componentDidUpdate(prevProps) {
    if (this.props.templatesActions && this.props.templatesActions.loadedTemplate) {
      if (
        this.props.templatesActions.loadedTemplate !== prevProps.templatesActions.loadedTemplate
      ) {
        const loadedTemplate = this.props.templatesActions.loadedTemplate.template_info[0]
        const templateItems = this.props.templatesActions.loadedTemplate.template_tasks
        if (loadedTemplate) {
          this.setState({
            templateName: loadedTemplate.name,
            templateDescription: loadedTemplate.description,
            requestedBy: loadedTemplate.requested_by,
            workOrderItems: templateItems
          })
        }
      }
    }
  }

  handleInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleCreate = () => {
    const { currentId, templateName, templateDescription, requestedBy, workOrderItems } = this.state
    const data = {
      requested_by: requestedBy,
      description: templateDescription,
      name: templateName,
      estimate_template_id: currentId,
      tasks: workOrderItems
    }
    if (currentId === 0) {
      this.props.createTemplate({
        templateType: 'work_order',
        content: data,
        userId: this.props.authentication.user.userId
      })
    } else {
      this.props.saveTemplate({
        templateId: this.state.currentId,
        templateType: 'work_order',
        content: data,
        userId: this.props.authentication.user.userId
      })
    }

    message.success('Changes saved.')
    this.setState({ contentData: null, currentId: 0, modalVisible: false })
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: 'work_order'
    })

    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  handleItemsChange = workOrderItems => {
    this.setState({
      workOrderItems
    })
  }

  handleItemInputChange = (value, key, column) => {
    const groupedItems = this.state.workOrderItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      workOrderItems: groupedItems
    })
  }

  editChangeOrderRow = rowId => {
    const groupedItems = this.state.workOrderItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      workOrderItems: groupedItems
    })
  }

  saveChangeOrderRow = rowId => {
    const groupedItems = this.state.workOrderItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      workOrderItems: groupedItems
    })
  }

  deleteChangeOrderRow = rowId => {
    const groupedItems = this.state.workOrderItems.filter(item => item.id !== rowId)

    this.setState({
      workOrderItems: groupedItems
    })
  }

  handleAddTaskInputChange = value => {
    this.setState({
      addTaskInput: value
    })

    const selectedTask = this.props.tasksActions.allTasks.data.filter(
      row => parseInt(row.id, 0) === parseInt(value, 0)
    )
    if (selectedTask.length > 0) {
      this.setState({
        addTaskName: selectedTask[0].name
      })
    }
  }

  handleAddDeviceNumberInputChange = value => {
    this.setState({
      addDeviceNumberInput: value
    })
  }

  handleAddMaterialsNeededInputChange = value => {
    this.setState({
      addMaterialsNeededInput: value
    })
  }

  handleAddItemClick = () => {
    const groupedItems = this.state.workOrderItems
    if (
      _.isEmpty(this.state.addTaskInput) ||
      _.isEmpty(this.state.addDeviceNumberInput) ||
      _.isEmpty(this.state.addMaterialsNeededInput)
    ) {
      message.warning('You need to fill all item informations.')
    } else {
      let selectedTaskName = null
      let selectesTaskId = null
      if (_.isEmpty(this.state.addTaskName)) {
        const selectedTask = this.props.tasksActions.allTasks.data.filter(
          row => row.name === this.state.addTaskInput
        )

        if (selectedTask.length > 0) {
          selectedTaskName = selectedTask[0].name
          selectesTaskId = selectedTask[0].id
          this.setState({
            addTaskName: selectedTask[0].name
          })
        }
      }

      groupedItems.push({
        task_id: selectesTaskId || this.state.addTaskInput,
        task_name: selectedTaskName || this.state.addTaskName,
        device_number: this.state.addDeviceNumberInput,
        materials_needed: this.state.addMaterialsNeededInput,
        id: groupedItems.length + 1
      })
      this.setState({
        workOrderItems: groupedItems,
        addTaskInput: '',
        addTaskName: '',
        addDeviceNumberInput: '',
        addMaterialsNeededInput: ''
      })
    }
  }

  handleTemplateChange = event => {
    const form = this.props.form
    const selectedTemplate = this.props.workOrderTemplatesActions.workOrderTemplates.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedTemplate.length > 0) {
      this.props.getWorkOrderTemplateItems(selectedTemplate[0].id)
      form.setFieldsValue({
        description: selectedTemplate[0].description,
        work_order_template_id: selectedTemplate[0].id
      })
    }
  }

  markTaskComplete = taskId => {
    this.props.markTaskComplete({
      jobId: this.props.jobId,
      taskId: taskId,
      workOrderId: this.state.currentId
    })
  }

  handleQuickAddTask = task => {
    this.props.mainQuickAddTask({
      task: task,
      userId: this.props.authentication.user.userId
    })
  }

  render() {
    return (
      <Container>
        <h2>Work Order Template</h2>
        <div className="row">
          <div className="col-md-12">
            <div>Template</div>
            <Input
              value={this.state.templateName}
              onChange={event => this.handleInputChange(event.target.value, 'templateName')}
            />
          </div>
        </div>
        <div>Description</div>
        <TextArea
          placeholder="Type in description..."
          rows={4}
          onChange={event => this.handleInputChange(event.target.value, 'templateDescription')}
          value={this.state.templateDescription}
        />
        <div className="row">
          <div className="col-md-12">
            <MarginTop>
              {this.state.currentId > 0 && (
                <Popconfirm
                  title="Are you sure you want to delete this record?"
                  onConfirm={this.confirmDelete}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="danger" icon="delete" className="mr-2" />
                </Popconfirm>
              )}
            </MarginTop>
          </div>
        </div>
        <WorkOrderEditor
          allTasks={
            this.props.tasksActions &&
            this.props.tasksActions.allTasks &&
            this.props.tasksActions.allTasks.data
          }
          workOrderItems={this.state.workOrderItems}
          handleItemsChange={this.handleItemsChange}
          editRow={this.editChangeOrderRow}
          saveRow={this.saveChangeOrderRow}
          deleteRow={this.deleteChangeOrderRow}
          handleAddTaskInputChange={this.handleAddTaskInputChange}
          handleAddDeviceNumberInputChange={this.handleAddDeviceNumberInputChange}
          handleAddMaterialsNeededInputChange={this.handleAddMaterialsNeededInputChange}
          handleAddItemClick={this.handleAddItemClick}
          handleInputChange={this.handleItemInputChange}
          addTaskInput={this.state.addTaskInput}
          addTaskName={this.state.addTaskName}
          addDeviceNumberInput={this.state.addDeviceNumberInput}
          addMaterialsNeededInput={this.state.addMaterialsNeededInput}
          isNew
          markTaskComplete={this.markTaskComplete}
          handleQuickAddTask={this.handleQuickAddTask}
        />
        <MarginTop>
          <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
          <Button type="primary" onClick={() => this.handleCreate()}>
            {this.state.currentId === 0 && <span>Create Template</span>}
            {this.state.currentId > 0 && <span>Save Changes</span>}
          </Button>
        </MarginTop>
      </Container>
    )
  }
}

const mapStateToProps = ({ templatesActions, tasksActions, authentication }, ownProps) => ({
  templatesActions,
  tasksActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, tasksActions), dispatch)
})

TemplatesWorkOrder.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplatesWorkOrder))



// WEBPACK FOOTER //
// ./src/containers/templates/workOrderTemplate.js